enum ScreenAccess {
  Full = 'full',
  Read = 'readOnly',
}

export default ScreenAccess;
